module.exports = __webpack_public_path__ + "static/media/doc01.81c172b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/LandingPage/images/doc01.jpg
// module id = 725
// module chunks = 0